module.exports = __webpack_public_path__ + "img/21.09b9af5a.jpg";